module.exports = __webpack_public_path__ + "static/media/Jose Ojeda.e8bad127.jpg";